module.exports = __webpack_public_path__ + "static/media/Asset1.65227d57.png";